export default __webpack_public_path__ + "static/media/Cluedo-Nudges-Teachers-Admin.fd6a1b7a.svg";